import { render } from "./ExpandIcon.vue?vue&type=template&id=ecb88900&scoped=true"
const script = {}

import "./ExpandIcon.vue?vue&type=style&index=0&id=ecb88900&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecb88900"]])

export default __exports__